import { useRecoilState, useRecoilValue } from 'recoil';
import { btnColor, userTenant } from '../../GlobalState';

import { DraggableProvided } from 'react-beautiful-dnd';
import { Checkbox, TableRow, Button } from '@material-ui/core';
import { StyledTableCell } from './Style';
import { TSetLocalStorage } from '../../pages/EditEstimates';
import { ESTIMATE_DEFAULT_ITEM_COUNT } from '../../const/Const';
import { EstimateItemInput } from '../EstimateItemInput';
import NumberInput from '../NumberInput';
import { convertToHalfWidthNumeric } from '../../utils/toHalfWidth';
import { parsePrice } from '../../utils';
import {
  handleTextValidation,
  getChildrenByIndexes,
  getEstimateItemByIndexes,
  findMUnitById
} from '../../utils/estimate';
import {
  TUpdateEstimateItemList,
  TAiAverageItem,
  CopyModalAction
} from '../../types/estimate/estimate';
import { TTenant } from '../../types/common';
import { AiItemPopup } from '../parts/aiPopup/AiItemPopup';
import { AiPricePopup } from '../parts/aiPopup/AiPricePopup';
import React from 'react';

type viewMode = 'layer' | 'all';

type TEstimateItemRow = {
  provided?: DraggableProvided;
  item: any;
  selected: boolean;
  indexes: number[];
  estimateItemList: any;
  classes: any;
  tableSized: number;
  mUnitsData: any;
  viewMode: viewMode;
  handleCheckItem: () => void;
  handleUnCheckItem: () => void;
  updateEstimateItemList: TUpdateEstimateItemList;
  handleDeleteItem: () => void;
  setLocalStorage: TSetLocalStorage;
  switchingDetailLayer?: (
    layer: number,
    index: number,
    itemName: string
  ) => void;
  copyModalDispatch: React.Dispatch<CopyModalAction>;
  showAiPricePopup?: boolean;
  priceAnchorEl?: HTMLElement | null;
  averagePriceList?: TAiAverageItem;
  isAiPriceLoading?: boolean;
  handleAiPricePopupClose?: () => void;
  setPriceAnchorEl?: (anchorEl: HTMLElement | null) => void;
  setShowAiPricePopup?: (showAiPricePopup: boolean) => void;
  handleError?: (message: string) => void;
  getListOfAiEstimatePrice?: (parentItem: string, subItem: string) => void;
};

export const EstimateItemRow = (props: TEstimateItemRow) => {
  const {
    provided,
    item,
    selected,
    indexes,
    estimateItemList,
    classes,
    tableSized,
    mUnitsData,
    viewMode,
    handleCheckItem,
    handleUnCheckItem,
    updateEstimateItemList,
    handleDeleteItem,
    setLocalStorage,
    switchingDetailLayer,
    copyModalDispatch,
    showAiPricePopup,
    priceAnchorEl,
    averagePriceList,
    isAiPriceLoading,
    handleAiPricePopupClose,
    setPriceAnchorEl,
    setShowAiPricePopup,
    handleError,
    getListOfAiEstimatePrice
  } = props;

  const [buttonColor] = useRecoilState(btnColor);
  const userTenantData = useRecoilValue<TTenant | undefined>(userTenant);

  /**
   * テキストエリア制御
   */
  const handleTextareaChange = (
    layer: number,
    key: 'spec' | 'remarks' | 'author_memo',
    text: any,
    indexes: number[]
  ) => {
    const rawText = text;
    let cleanText = '';
    let charCount = 0;
    let lineCount = 1;
    let newlineInserted = false;
    let existingNewlineIndex = rawText.search(/\r\n|\n|\r/);

    for (let i = 0; i < rawText.length; i++) {
      if (rawText[i] === '\n' || rawText[i] === '\r') {
        if (rawText[i] === '\r' && rawText[i + 1] === '\n') {
          i++;
        }
        if (newlineInserted) {
          // 既に改行が挿入されている場合の警告
          if (i > existingNewlineIndex) {
            alert('2行以内で入力してください');
          } else {
            alert('1行20文字以内で入力してください');
          }
          break;
        } else if (charCount > 20) {
          // 1行目が20文字を超えている場合
          alert('1行20文字以内で入力してください');
          break;
        }
        newlineInserted = true;
        existingNewlineIndex = i;
        charCount = 0;
        lineCount++;
      } else {
        charCount++;
      }
      // 改行後の行で20文字を超えた場合、入力を停止
      if (newlineInserted && charCount > 20) {
        alert('1行20文字以内で入力してください');
        break;
      }

      if (charCount > 40) break;
      cleanText += rawText[i];
    }

    updateEstimateItemList({ key, value: cleanText }, indexes);
  };

  let index = indexes.at(-1)!;

  const itemCountIsNotDefaultCount = () => {
    let items = getChildrenByIndexes(estimateItemList, indexes.slice(0, -1));
    return items.length !== ESTIMATE_DEFAULT_ITEM_COUNT;
  };

  return (
    <>
      <TableRow
        ref={provided?.innerRef}
        {...provided?.draggableProps}
        {...provided?.dragHandleProps}
      >
        <StyledTableCell
          className={classes.tableBodyItems}
          align='center'
          style={{ width: 50 }}
        >
          <Checkbox
            // checked={selectedItem.arr.includes(item.id) ? true : false}
            checked={selected}
            onClick={() => {
              if (!selected) {
                handleCheckItem();
              } else {
                handleUnCheckItem();
              }
            }}
            style={{
              color: selected ? buttonColor : '#758283'
            }}
          />
        </StyledTableCell>
        <StyledTableCell
          className={classes.tableBodyItems}
          align='center'
          style={{ width: 100 }}
        >
          {item.layer !== 5 &&
            (item.hasUnderLayerFlg == true ||
              (item.sellingUnitPrice == 0 && item.costUnitPrice == 0)) && (
              <select
                value={item.hasUnderLayerFlg ? 'true' : 'false'}
                disabled={
                  item.hasUnderLayerFlg == true && item.childItems.length > 0
                }
                onChange={text => {
                  updateEstimateItemList(
                    {
                      key: 'hasUnderLayerFlg',
                      value: text.target.value === 'true' ? true : false
                    },
                    indexes
                  );
                }}
                onBlur={(text: any) => {
                  setLocalStorage(
                    'estimateItemList',
                    JSON.stringify(estimateItemList)
                  );
                }}
                className={classes.selectLayerType}
                name='cars'
                form='carform'
              >
                <option value='true'>明細あり</option>
                <option value='false'>明細なし</option>
              </select>
            )}
        </StyledTableCell>
        {viewMode === 'layer' && (
          <StyledTableCell
            className={classes.tableBodyItems}
            align='center'
            style={{ width: 100 }}
          >
            <div className={classes.inputMainContainer}>
              <div className={classes.inputContainer}>
                {item.layer !== 5 && item.hasUnderLayerFlg == true && (
                  <Button
                    style={{
                      backgroundColor: buttonColor,
                      height:
                        tableSized === 50 ? 40 : tableSized === 0 ? 35 : 50
                    }}
                    variant='contained'
                    color='primary'
                    onClick={() => {
                      switchingDetailLayer!(item.layer + 1, index, item.name);
                    }}
                  >
                    明細
                  </Button>
                )}
              </div>
            </div>
          </StyledTableCell>
        )}
        {viewMode === 'all' && (
          <StyledTableCell
            className={classes.tableBodyItemsMain}
            align='center'
            style={{ width: 50 }}
          >
            {item.layer}
          </StyledTableCell>
        )}
        <StyledTableCell
          className={classes.tableBodyItems}
          align='center'
          style={{ width: 300 }}
        >
          <div className={classes.inputMainContainer}>
            <div className={classes.inputContainer}>
              <input
                value={item.name}
                autoFocus={
                  item.name === '' &&
                  typeof item.id === 'string' &&
                  // estimateItemList.length !== ESTIMATE_DEFAULT_ITEM_COUNT ?
                  itemCountIsNotDefaultCount()
                    ? true
                    : false
                }
                maxLength={20}
                placeholder={'20文字以内で入力'}
                onChange={text => {
                  handleTextValidation(
                    text.target.value,
                    20,
                    null,
                    null,
                    cleanText => {
                      updateEstimateItemList(
                        { key: 'name', value: cleanText },
                        indexes
                      );
                    }
                  );
                }}
                onBlur={text => {
                  setLocalStorage(
                    'estimateItemList',
                    JSON.stringify(estimateItemList)
                  );
                }}
                className={`${classes.input2}`}
              />
            </div>
          </div>
          {userTenantData?.estimate_auto && item.layer === 2 && (
            <AiItemPopup
              estimateItem={
                getEstimateItemByIndexes(estimateItemList, indexes.slice(0, -1))
                  .name
              }
              updateEstimateItemList={updateEstimateItemList}
              parentItemIndex={indexes.at(-1)!}
              sub_index={index}
              handleError={handleError!}
            />
          )}
        </StyledTableCell>
        <StyledTableCell
          className={classes.tableBodyItems}
          align='center'
          style={{ width: 300 }}
        >
          <div className={classes.inputMainContainer}>
            <div className={classes.inputContainer}>
              <textarea
                value={item.spec}
                style={{ height: 45, width: 290, maxHeight: 80 }}
                maxLength={42}
                placeholder={'40文字以内、2行以内'}
                onChange={e =>
                  handleTextValidation(
                    e.target.value,
                    40,
                    null,
                    null,
                    cleanText => {
                      handleTextareaChange(
                        item.layer,
                        'spec',
                        cleanText,
                        indexes
                      );
                    }
                  )
                }
                onBlur={text => {
                  setLocalStorage(
                    'estimateItemList',
                    JSON.stringify(estimateItemList)
                  );
                }}
                className={`${classes.input2}`}
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell
          className={classes.tableBodyItems}
          align='center'
          style={{ width: 120 }}
        >
          <div
            className={`${classes.inputMainContainerItems} ${classes.subTopCell}`}
          >
            <div className={classes.inputDetailContainer}>
              <EstimateItemInput
                estimateItemList={estimateItemList}
                item={item}
                indexes={indexes}
                updateEstimateItemList={updateEstimateItemList}
                fieldName='quantity'
                minValue={0}
                maxValue={Number.MAX_SAFE_INTEGER}
                setLocalStorage={setLocalStorage}
                classes={classes}
                classNameString='smallQuantityInputItems'
              />
            </div>
          </div>
          <div
            className={`${classes.inputMainContainerItems} ${classes.subCell}`}
          >
            <div className={classes.inputDetailContainer}>
              <EstimateItemInput
                estimateItemList={estimateItemList}
                item={item}
                indexes={indexes}
                updateEstimateItemList={updateEstimateItemList}
                fieldName='costQuantity'
                minValue={0}
                maxValue={Number.MAX_SAFE_INTEGER}
                setLocalStorage={setLocalStorage}
                classes={classes}
                classNameString='smallQuantityInputItems'
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell
          className={classes.tableBodyItems}
          align='center'
          style={{ width: 120 }}
        >
          <div
            className={`${classes.inputMainContainerItems} ${classes.subTopCell}`}
          >
            <div className={classes.inputDetailContainer}>
              <select
                value={item.unitId}
                onChange={text => {
                  updateEstimateItemList(
                    {
                      key: 'unit',
                      value: findMUnitById(
                        mUnitsData,
                        Number(text.target.value)
                      )
                    },
                    indexes
                  );
                }}
                onBlur={text => {
                  setLocalStorage(
                    'estimateItemList',
                    JSON.stringify(estimateItemList)
                  );
                }}
                className={classes.selectBoxStyleItems}
                name='cars'
                form='carform'
              >
                <option value='0'>---</option>
                {mUnitsData.map((i: any) => (
                  <option value={i.id}>{i.name}</option>
                ))}
              </select>
            </div>
          </div>
          <div
            className={`${classes.inputMainContainerItems} ${classes.subCell}`}
          >
            <div className={classes.inputDetailContainer}>
              （
              <select
                value={item.costUnitId}
                onChange={text => {
                  updateEstimateItemList(
                    {
                      key: 'costUnit',
                      value: findMUnitById(
                        mUnitsData,
                        Number(text.target.value)
                      )
                    },
                    indexes
                  );
                }}
                onBlur={text => {
                  setLocalStorage(
                    'estimateItemList',
                    JSON.stringify(estimateItemList)
                  );
                }}
                className={classes.selectBoxCostItems}
                name='cars'
                form='carform'
              >
                <option value='0'>---</option>
                {mUnitsData.map((i: any) => (
                  <option value={i.id}>{i.name}</option>
                ))}
              </select>
              ）
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell
          className={classes.tableBodyItems}
          align='right'
          style={{ width: 100 }}
        >
          <div
            className={`${classes.inputMainContainerItems} ${classes.subTopCell}`}
          >
            <div className={classes.inputDetailContainer}>
              <NumberInput
                value={
                  item.sellingUnitPrice === 0 ? '0' : item.sellingUnitPrice
                }
                disabled={item.hasUnderLayerFlg == true}
                onClick={
                  item.layer === 2
                    ? (e: React.FocusEvent<HTMLElement>) => {
                        const parentItem = getEstimateItemByIndexes(
                          estimateItemList,
                          indexes.slice(0, -1)
                        );
                        if (
                          item.name !== '' &&
                          parentItem.name !== '' &&
                          userTenantData?.estimate_auto
                        ) {
                          getListOfAiEstimatePrice!(parentItem.name, item.name);
                          setPriceAnchorEl!(e.target);
                          setShowAiPricePopup!(true);
                        }
                      }
                    : undefined
                }
                onBlur={(text: any) => {
                  let input = text.target.value;
                  input = convertToHalfWidthNumeric(
                    input,
                    Number.MIN_SAFE_INTEGER,
                    Number.MAX_SAFE_INTEGER
                  );
                  updateEstimateItemList(
                    { key: 'sellingUnitPrice', value: parseFloat(input) },
                    indexes
                  );
                  setLocalStorage(
                    'estimateItemList',
                    JSON.stringify(estimateItemList)
                  );
                }}
                symbol=''
                className={classes.smallInputItems}
                dynamicCalculation={true}
              />
              {userTenantData?.estimate_auto &&
                showAiPricePopup &&
                item.layer === 2 && (
                  <AiPricePopup
                    showAiPricePopup={showAiPricePopup}
                    priceAnchorEl={priceAnchorEl!}
                    averagePriceList={averagePriceList!}
                    isAiPriceLoading={isAiPriceLoading!}
                    handleAiPricePopupClose={handleAiPricePopupClose!}
                  />
                )}
            </div>
          </div>
          <div
            className={`${classes.inputMainContainerItems} ${classes.subCell}`}
          >
            <div className={classes.inputDetailContainer}>
              （
              <NumberInput
                value={item.costUnitPrice === 0 ? '0' : item.costUnitPrice}
                disabled={item.hasUnderLayerFlg == true}
                onBlur={(text: any) => {
                  let input = text.target.value;
                  input = convertToHalfWidthNumeric(
                    input,
                    Number.MIN_SAFE_INTEGER,
                    Number.MAX_SAFE_INTEGER
                  );
                  updateEstimateItemList(
                    { key: 'costUnitPrice', value: parseFloat(input) },
                    indexes
                  );
                  setLocalStorage(
                    'estimateItemList',
                    JSON.stringify(estimateItemList)
                  );
                }}
                symbol=''
                className={classes.smallCostInputItems}
                dynamicCalculation={true}
              />
              ）
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell
          className={classes.tableBodyItems}
          align='right'
          style={{ width: 120 }}
        >
          <div
            className={`${classes.inputMainContainerItems} ${classes.subTopCell}`}
          >
            <div className={classes.inputContainer}>
              {parsePrice(item.allSellingPrice, '')}
            </div>
          </div>
          <div
            className={`${classes.inputMainContainerItems} ${classes.subCell}`}
          >
            {item.allCostPrice !== '' && (
              <div className={classes.inputAllCostPriceContainer}>
                （
                <span style={{ color: 'blue' }}>
                  {parsePrice(item.allCostPrice, '')}
                </span>
                ）
              </div>
            )}
          </div>
        </StyledTableCell>

        <StyledTableCell
          className={classes.tableBodyItems}
          align='right'
          style={{ width: 80 }}
        >
          <div className={classes.inputMainContainer}>
            <div className={classes.inputContainer}>
              {parsePrice(item.grossProfit, '')}
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell
          className={classes.tableBodyItems}
          align='center'
          style={{ width: 80 }}
        >
          <div className={classes.inputMainContainer}>
            <div className={classes.grossProfitMarginContainer}>
              <EstimateItemInput
                estimateItemList={estimateItemList}
                item={item}
                indexes={indexes}
                updateEstimateItemList={updateEstimateItemList}
                fieldName='grossProfitMargin'
                minValue={0}
                maxValue={100}
                setLocalStorage={setLocalStorage}
                classes={classes}
                classNameString='inputGrossProfitMarginAlignRight'
              />
              <div style={{ marginLeft: 4 }}>%</div>
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell
          className={classes.tableBodyItems}
          align='center'
          style={{ width: 300 }}
        >
          <div className={classes.inputMainContainer}>
            <div
              className={classes.inputContainer}
              style={{
                display: 'flex',
                flexDirection: 'column',
                height: tableSized === 50 ? 70 : tableSized === 0 ? 58 : 100,
                gap: tableSized === 50 ? 2 : tableSized === 0 ? 0 : 8,
                fontSize: tableSized === 50 ? 9.8 : tableSized === 0 ? 8 : 14
              }}
            >
              <textarea
                value={item.remarks}
                style={{ flex: 1, width: 290 }}
                maxLength={42}
                placeholder={'【備考】40文字以内、2行以内'}
                onChange={e =>
                  handleTextValidation(
                    e.target.value,
                    40,
                    2,
                    null,
                    cleanText => {
                      handleTextareaChange(
                        item.layer,
                        'remarks',
                        cleanText,
                        indexes
                      );
                    }
                  )
                }
                onBlur={text => {
                  setLocalStorage(
                    'estimateItemList',
                    JSON.stringify(estimateItemList)
                  );
                }}
                className={`${classes.input2}`}
              />
              <textarea
                value={item.author_memo}
                style={{ flex: 1, width: 290 }}
                maxLength={42}
                placeholder={'【社内用メモ】40文字以内、2行以内'}
                onChange={e =>
                  handleTextValidation(
                    e.target.value,
                    40,
                    2,
                    null,
                    cleanText => {
                      handleTextareaChange(
                        item.layer,
                        'author_memo',
                        cleanText,
                        indexes
                      );
                    }
                  )
                }
                onBlur={text => {
                  setLocalStorage(
                    'estimateItemList',
                    JSON.stringify(estimateItemList)
                  );
                }}
                className={`${classes.smallmemoInputItems}`}
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell
          className={classes.tableBodyItems}
          align='center'
          style={{ width: 100 }}
        >
          <div className={classes.inputMainContainer}>
            <div className={classes.inputContainer}>
              <Button
                style={{
                  backgroundColor: buttonColor,
                  height: tableSized === 50 ? 40 : tableSized === 0 ? 35 : 50
                }}
                variant='contained'
                color='primary'
                onClick={handleDeleteItem}
              >
                削除
              </Button>
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell
          className={classes.tableBodyItems}
          align='center'
          style={{ width: 100 }}
        >
          <div className={classes.inputMainContainer}>
            <div className={classes.inputContainer}>
              <Button
                style={{
                  backgroundColor: buttonColor,
                  height: tableSized === 50 ? 40 : tableSized === 0 ? 35 : 50
                }}
                variant='contained'
                color='primary'
                onClick={() => {
                  copyModalDispatch({ type: 'open', copyItem: item });
                }}
              >
                コピー
              </Button>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
    </>
  );
};
